import React, {CSSProperties, ReactNode} from 'react'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {IconButton} from '../buttons'
import {Padding} from '../design-system/types'
import {Icon} from '../icon'
import {
  TwHeader,
  TwHeaderSubtitleTitle,
  TwHeaderTitle,
  TwHeaderTitleWrapper
} from './containers'

export interface Props {
  type: 'popup' | 'dialog'
  title: ReactNode
  subTitle?: string
  icon?: TablerIcons
  onClose?: () => void
  paddings?: Padding
  noCross?: boolean
  autoHeightHeader?: boolean
  headerStyle?: CSSProperties
}

const getIconSize = (paddings: Padding) => {
  if (paddings === 16) {
    return 16
  }
  return 24
}

export const PopupHeader = (props: Props) => {
  const {
    icon,
    title,
    onClose,
    paddings = 24,
    type,
    noCross,
    autoHeightHeader,
    subTitle,
    headerStyle
  } = props
  const iconSize = getIconSize(paddings)

  return (
    <TwHeader
      $paddings={paddings}
      $type={type}
      $autoHeightHeader={autoHeightHeader}
      style={headerStyle}
    >
      {icon && <Icon icon={icon} size={iconSize} color="secondary" />}
      <TwHeaderTitleWrapper>
        <TwHeaderTitle>{title}</TwHeaderTitle>
        {Boolean(subTitle) && (
          <TwHeaderSubtitleTitle>{subTitle}</TwHeaderSubtitleTitle>
        )}
      </TwHeaderTitleWrapper>
      {!noCross && (
        <IconButton
          icon="IconCustomClose"
          onClick={onClose}
          color="secondary"
          size="small"
        />
      )}
    </TwHeader>
  )
}
